import React from "react";
import ReactDOM from "react-dom";

export default function() {
  Array.prototype.forEach.call(document.querySelectorAll("[data-component-name]"), function(node) {
    ReactDOM.unmountComponentAtNode(node);
  });
}



// WEBPACK FOOTER //
// ./app/javascript/utils/react_unloader.js